export enum MfeBlockVariant {
  ECONOMIC_CALENDAR = 'economic-calendar',
}

interface MfeI {
  mfeVariant: MfeBlockVariant;
}

export interface MfeBlockI {
  reference: MfeI[];
}
